import React from 'react';
import { Route, NotFound } from 'cccisd-laravel-boilerplate';
import { Redirect, Switch } from 'cccisd-react-router';
import { Dashboard as AppdefDashboard, AdminRoutes, Manage as AppdefManage } from 'cccisd-laravel-appdefs';
import { AuthRedirect } from 'cccisd-laravel-nexus';
import { Quest } from 'cccisd-laravel-assignment';

// Layouts
import MainLayout from './layouts/MainLayout';
import QuestLayout from './layouts/QuestLayout';

// Pages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Welcome from './pages/Welcome'; // Include it into main bundle

// Components
import BrowserTest from 'bundle-loader?lazy!./components/BrowserTest';
import StudentLanding from 'bundle-loader?lazy!./components/StudentLanding';
import StudentAssignment from 'bundle-loader?lazy!./components/StudentAssignment';
import StudentRedirect from 'bundle-loader?lazy!./components/StudentRedirect';
import TeacherAssignment from 'bundle-loader?lazy!./components/TeacherAssignment';
import Resources from 'bundle-loader?lazy!cccisd-laravel-resources';

import RequireSecureWrapper from './components/RequireSecureWrapper';
import SetInsecureWrapper from './components/SetInsecureWrapper';
import CoequalChoices from './components/CoequalChoices';
import TeacherAdministrative from './components/TeacherAdministrative';
import Administrative from './components/Administrative';

// Laravel packages
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';
import { getHomeRoute } from './helpers';

// Create Secure/SetInsecure versions of Components
const SecuredAppdefDashboard = props => <RequireSecureWrapper wrappedComponent={AppdefDashboard} {...props} />;
const SetInsecureAppdefDashboard = props => <SetInsecureWrapper wrappedComponent={AppdefDashboard} {...props} />;
const SecuredTeacherAdministrative = props => (
    <RequireSecureWrapper wrappedComponent={TeacherAdministrative} {...props} />
);
const SecuredAdministrative = props => <RequireSecureWrapper wrappedComponent={Administrative} {...props} />;

// Bind MainLayout by default
const AppRoute = p => <Route layout={MainLayout} {...p} />;

const MainLayoutFluid = p => <MainLayout className="container-fluid" {...p} />;
const StudentLayout = p => <MainLayout className="container-fluid" showFooter={false} noLogoLink {...p} />;

let Fortress = window.cccisd.fortress;
let AppDefinitions = window.cccisd.appDefs;

const componentMatch = {
    Administrative,
    AppdefDashboard,
    AppdefManage,
    BrowserTest,
    CoequalChoices,
    SecuredAppdefDashboard,
    SetInsecureAppdefDashboard,
    SecuredTeacherAdministrative,
    SecuredAdministrative,
    StudentLanding,
    StudentAssignment,
    StudentRedirect,
    TeacherAssignment,
    Welcome,
};

const layoutMatch = {
    MainLayout,
    MainLayoutFluid,
    StudentLayout,
};

export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const Component = componentMatch[route.componentHandle];
            if (!Component) {
                return null;
            }

            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    exact
                    layout={'layout' in route && layoutMatch[route.layout] ? layoutMatch[route.layout] : MainLayout}
                />
            );
        })}
        <AppRoute path="/" component={Welcome} exact />
        <AppRoute path="/welcome" component={Welcome} />
        {Fortress.auth() && <AppRoute path="/login" component={Redirect} componentProps={{ to: getHomeRoute() }} />}
        <AppRoute path="/test" component={BrowserTest} />

        <AppRoute path={['/quest/preview', '/d', '/survey']} component={Quest} layout={QuestLayout} />

        {/* Laravel packages routes */}
        {AdminRoutes(MainLayoutFluid)}

        <AppRoute
            path="/account"
            layout={null}
            component={Nexus}
            componentProps={{ defaultLayout: MainLayout, registrationSurveyLayout: QuestLayout }}
        />

        <AppRoute path="/downloads" component={Resources} />

        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />

        {/* Not found page */}
        <AppRoute component={NotFound} />
    </Switch>
);
